export const policySortingColumns = [
    'company',
    'expirationDate',
    'currencyCode',
    'number',
    'typeCode',
    'status',
    'updatedAt',
    'acceptanceRate',
    'activeCoverages',
    'activeInsistences',
];
